export const defaultTranslations = {
    inputPlaceholder: 'What are you looking for?',
    sectionPreviousSearchesTitle: 'Previous Searches',
    sectionPopularSearchesTitle: 'Popular Searches',
    sectionCasinoGamesTitle: 'Gaming',
    sectionEventsTitle: 'Events',
    sectionHelpAnswersTitle: 'Help',
    sectionLeaguesTitle: 'Leagues',
    sectionMatchesTitle: 'Matches',
    sectionPromotionTitle: 'Promotions',
    sectionRacesTitle: 'Races',
    sectionSelectionsTitle: 'Selections',
    sectionSportsTitle: 'Sports',
    sectionTournamentsTitle: 'Tournaments',
    raceGoing: 'Going',
    noResultsFoundTitle: 'No results found',
    noResultsFoundDescription: "Unfortunately we weren't able to find what you were looking for",
    searchTitle: 'Search',
};
//# sourceMappingURL=translations.js.map